import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { EASE } from "@/components/motion";

export default function LegalModal({ open, onClose, title, version, doc, testid }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[110] bg-night/80 backdrop-blur-md flex items-end md:items-center justify-center p-0 md:p-8"
          onClick={onClose}
          data-testid={testid}
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          <motion.div
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 80, opacity: 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-3xl max-h-[85vh] bg-abyss border border-silver/15 flex flex-col"
          >
            <div className="flex items-center justify-between px-7 md:px-10 py-6 border-b border-silver/10 shrink-0">
              <div>
                <span className="font-mono text-[10px] tracking-[0.35em] text-glow/80 block mb-2">
                  {version ? `VERSIÓN ${version}` : "DOCUMENTO LEGAL"}
                </span>
                <h2 className="font-oswald font-600 uppercase text-xl md:text-2xl tracking-wide text-offwhite">
                  {title}
                </h2>
              </div>
              <button
                onClick={onClose}
                data-testid={`${testid}-close`}
                aria-label="Cerrar documento"
                className="text-mist hover:text-offwhite transition-colors duration-300 p-2 -mr-2"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="overflow-y-auto px-7 md:px-10 py-8 space-y-8">
              {doc.map((s) => (
                <section key={s.title}>
                  <h3 className="font-mono text-[11px] tracking-[0.25em] text-silver mb-3 uppercase">{s.title}</h3>
                  {s.body && <p className="text-mist text-sm leading-relaxed">{s.body}</p>}
                  {s.list && (
                    <ul className="mt-3 space-y-2">
                      {s.list.map((item) => (
                        <li key={item} className="flex gap-3 text-mist text-sm leading-relaxed">
                          <span className="mt-[0.65em] h-px w-4 shrink-0 bg-glow/50" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.table && (
                    <div className="mt-4 overflow-x-auto border border-silver/10">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="border-b border-silver/10">
                            {s.table.head.map((h) => (
                              <th key={h} className="px-4 py-3 text-left font-mono text-[10px] tracking-[0.2em] text-steel uppercase">
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {s.table.rows.map((row) => (
                            <tr key={row[0]} className="border-b border-silver/5 last:border-0">
                              {row.map((cell, ci) => (
                                <td key={ci} className={`px-4 py-3 ${ci === 0 ? "font-mono text-silver" : "text-mist"}`}>
                                  {cell}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {s.after && <p className="mt-3 text-mist text-sm leading-relaxed">{s.after}</p>}
                </section>
              ))}
            </div>
            <div className="px-7 md:px-10 py-5 border-t border-silver/10 shrink-0">
              <button
                onClick={onClose}
                data-testid={`${testid}-accept-close`}
                className="w-full md:w-auto font-mono text-[11px] tracking-[0.25em] bg-silver text-night px-8 py-3.5 hover:bg-offwhite transition-colors duration-300"
              >
                ENTENDIDO
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
